const trait = new Proxy(
  {},
  {
    get(target, key) {
      return (target[key] ??= Symbol(key));
    },
  },
);

export default trait;
